<template>
  <tg-layout>
    <template slot="header">
      <tg-button
        v-if="!isSub"
        round
        border
        hoverBorderOnly
        theme="primary"
        @click.native="handleAdd"
      >
        <template slot="icon" slot-scope="scope">
          <i
            class="tg-icon tg-icon-add-member"
            :class="{ active: scope.isHover }"
          ></i>
        </template>
        {{ $t("component.btn.add") }}
      </tg-button>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
    >
      <template slot="subUserName" slot-scope="scope">
        <span class="as-link" @click="handleClick(scope.column, scope.row)">{{
          scope.value
        }}</span>
      </template>
      <template slot="status" slot-scope="scope">
        <span>{{ $t("enum.active[" + scope.value + "]") }}</span>
      </template>
    </tg-table>
    <tg-dialog
      ref="dialog"
      :show-close="true"
      theme="info"
      :showIcon="false"
      width="70%"
      :title="dialog.title"
      :visible.sync="dialog.visible"
      destroy-on-close
      :showFooter="!isSub"
      append-to-body
      custom-class="tg-confirm-dialog"
      @on-confirm="handleConfirm"
      :confirmLabel="confirmLabel"
    >
      <tg-form-table
        :columns="computedProfileColumns"
        :data.sync="profileData"
        :fenceRow="fenceRow"
        :fenceCol="fenceCol"
        :columnWidth="250"
        :cellWidth="400"
      >
        <template slot="userfullname" slot-scope="scope">
          <template v-if="dialog.isAdd">
            <el-input
              v-model="profileData.username"
              class="tg-input col-8"
              size="small"
              clearable
            >
              <template slot="prepend">{{ username }}a</template>
            </el-input>
          </template>
          <template v-else>{{ scope.value }}</template>
        </template>
        <template slot="password" slot-scope="scope">
          <el-input
            v-if="!isSub"
            :placeholder="$t('component.form.input.placeholder.password[1]')"
            v-model="profileData[scope.column.name]"
            class="tg-input col-8"
            size="small"
            type="password"
            clearable
          ></el-input>
        </template>
        <template slot="status" slot-scope="scope">
          <tg-dropdown
            v-if="!isSub"
            :items="dropdown"
            trigger="click"
            @on-change="handleActiveChange($event, scope.column.name)"
          ></tg-dropdown>
          <span v-else>{{ $t("enum.active[" + scope.value + "]") }}</span>
        </template>

        <template slot="permission" slot-scope="scope">
          <el-radio-group
            v-model="profileData.permission[scope.column.id]"
            style="display: flex; justify-content: center"
          >
            <el-radio :label="0" :name="scope.id" size="small"
              >{{ $t("enum.admin.permission.radio[0]") }} </el-radio
            ><br />
            <el-radio :label="1" :name="scope.column.id" size="small"
              >{{ $t("enum.admin.permission.radio[1]") }}
            </el-radio>
            <el-radio
              :label="2"
              :name="scope.column.id"
              size="small"
              :disabled="scope.column.value < 2"
              >{{ $t("enum.admin.permission.radio[2]") }}
            </el-radio>
          </el-radio-group>
        </template>
      </tg-form-table>
    </tg-dialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgButton from "@/components/button/TgButton";
import TgDialog from "@/components/dialog/TgDialog";
import TgFormTable from "@/components/table/TgFormTable";
import TgDropdown from "@/components/dropdown/TgDropdown";

import apis from "@/apis";
const api = apis.member.admin;

import validator from "@/mixins/validator";

export default {
  mixins: [validator],
  components: {
    TgLayout,
    TgTable,
    TgButton,
    TgDialog,
    TgFormTable,
    TgDropdown,
  },
  data() {
    return {
      columns: [],
      profileColumns: [],
      profileColumnsOrigin: [],
      dropdown: [],
      proxy: api.getData,
      dialog: {
        title: this.$t("column.sub_admin_account"),
        isAdd: false,
        visible: false,
      },
      fenceRow: 3,
      fenceCol: 2,
      profileData: {
        username: "",
        subUserName: "",
        permission: [],
      },
      permission_origin: [],
      permission: [],
    };
  },
  computed: {
    username() {
      return this.$user.username;
    },
    confirmLabel() {
      return this.$t("component.btn.save");
    },
    computedProfileColumns() {
      if (this.dialog.isAdd) {
        return this.profileColumns.filter((x) => {
          return x.name != "lastLogin";
        });
      } else {
        return this.profileColumns;
      }
    },
  },
  created() {
    api.getColumns().then((response) => {
      this.columns = response.data.columns;
      this.profileColumnsOrigin = response.data.profileColumns;
      this.profileColumns = JSON.parse(
        JSON.stringify(this.profileColumnsOrigin),
      );
      api.getPermissions().then((result) => {
        this.permission_origin = result.data;
        this.permission = result.data;
        Object.keys(result.data).forEach((element) => {
          this.profileColumns.push({
            id: element,
            langKey: "admin.permission[" + element + "]",
            value: result.data[element],
            slot: "permission",
          });
        });
        this.$refs.table.init();
      });
    });
  },
  methods: {
    handleAdd() {
      this.profileData = {};
      this.dialog.isAdd = true;
      let dropdown = this.parseDropdown(0);
      this.profileData.status = dropdown[0].value;
      this.profileData.permission = this.permission;
      this.dropdown = dropdown;
      this.dialog.visible = true;
    },
    handleActiveChange(item, columnName) {
      this.profileData[columnName] = item.value;
    },
    handleConfirm(e) {
      const proxy = this.dialog.isAdd ? api.add : api.update;

      if (
        this.dialog.isAdd &&
        !this.validatePassword(this.profileData.password)
      ) {
        e.preventDefault = true;
        return;
      }

      if (
        this.profileData.password &&
        !this.validatePasswordChange(
          this.profileData.password,
          this.profileData.repassword,
        )
      ) {
        e.preventDefault = true;
        return;
      }

      let username = this.profileData.subUserName;

      if (this.dialog.isAdd) {
        if (this.profileData.username) {
          username = this.username + "a" + this.profileData.username;
        } else {
          e.preventDefault = true;
          this.$message.error(this.$t("column.input_username_placeholder"));
          return;
        }
      }

      proxy({
        ...this.profileData,
        username,
      }).then((response) => {
        if (response.retcode == 0) {
          this.$message.success(this.$t("message.success.update"));
          this.$refs.table.refresh();
        } else {
          this.$message.error(this.$t("statusCode[" + response.retcode + "]"));
        }
      });
    },
    handleClick(column, row) {
      this.$store.commit("TOGGLE_FULL_SCREEN_LOADING", true);
      api.getPermissions({ admin_name: row.subUserName }).then((result) => {
        this.permission_origin = result.data;
        this.permission = result.data;
        this.profileColumns = JSON.parse(
          JSON.stringify(this.profileColumnsOrigin),
        );
        Object.keys(result.data).forEach((element) => {
          this.profileColumns.push({
            id: element,
            langKey: "admin.permission[" + element + "]",
            value: result.data[element],
            slot: "permission",
          });
        });
        this.profileData = { ...row };
        this.profileData.permission = result.data;
        this.$store.commit("TOGGLE_FULL_SCREEN_LOADING", false);
      });

      this.dropdown = this.parseDropdown(row.status);
      this.dialog.isAdd = false;
      this.dialog.visible = true;
    },
    parseDropdown(status) {
      return [
        {
          value: 0,
          label: this.$t("enum.active[0]"),
          active: status == 0,
        },
        {
          value: 1,
          label: this.$t("enum.active[1]"),
          active: status == 1,
        },
      ];
    },
  },
};
</script>
